import useMap from "../../../utils/useMap";
import useWeakMap from "../../../utils/useWeakMap";
import { runExtractValue } from "../../executor";
import { convertToPropAccessByBracket, extractContentByTag } from "../../util";
import { canBindingNode } from "../useBinding";
import useWatcher from "../useWatcher";



const caching = useWeakMap();


/**
 * 
 * @param {Node} node 
 * @param {object} props 
 * @param {Array.<{attrName, attrValue, searches: Arra<[searchText, propText]>}>} attrListing 
 * @param {string} keyChanged 
 * @returns 
 */
const render = (() => {

    const cachingValue = useMap();

    const canRender = (keyChanged, attrValue) => typeof keyChanged === 'string' && !attrValue.includes(keyChanged)

    return (node, props, attrListing, keyChanged) => {
        if (!canBindingNode(node)) return;
        if (!attrListing || attrListing.length === 0) return;
        for (let idx in attrListing) {
            const { attrName, attrValue, searches } = attrListing[idx];
            if (canRender(keyChanged, attrValue)) {
                continue;
            }
            let newValue = attrValue;
            for (let i in searches) {
                const [searchText, propText] = searches[i];
                const propValue = runExtractValue(props, propText);
                newValue = newValue.replace(searchText, propValue);
            }
            node.setAttribute(attrName, newValue);
        }
    }
})();

const useInterpolationForAttribute = (() => {

    const valueCaching = useMap();


    /**
     * @param {{ attrName: string, attrValue: string }} attr
     * @param {object} props
     * @param {Node} node
     */
    return (attr, props, node) => {
        if (!caching.has(node)) {
            caching.set(node, []);
        }
        const { attrName, attrValue } = attr;
        const attrListing = caching.get(node);
        const searches = extractContentByTag(attrValue);
        if (searches.length === 0) {
            return Promise.resolve()
        }
        attrListing.push({ attrName, attrValue, searches });
        const propNameDeps = searches.map(item => item[1]);

        if (propNameDeps.length === 0) { }

        const { onPropChanges, onCreated, onDestroy } = useWatcher(props, node, propNameDeps);

        onDestroy(() => {
            caching.delete(node);
        })

        onPropChanges((p, key) => {
            render(node, props, attrListing, key)
        });

        return Promise.resolve();
    }
})();

export default useInterpolationForAttribute;